import CreateProductProfile from './CreateProductProfile';

export default CreateProductProfile;
